export enum AgentStatus {
  IDLE = 'idle',
  WORKING = 'working',
  SUCCEEDED = 'succeeded',
  ERROR = 'error',
}

export enum AgentContentType {
  DICTIONARY = 'dictionary',
  NOTE = 'note',
  QUIZ = 'quiz',
  FIGURE = 'figure',
}

export interface AgentCreatedContent {
  id: number
  type: AgentContentType
  title: string
  createdAt: string
  route?: string
}

export interface CourseSession {
  id: number
  title: string
  date: string // ISO date
  completed: boolean
  moduleNumber: number
  contentIds: number[]
}

export interface QuizResult {
  quizId: number
  title: string
  score: number // 0-100
  takenAt: string
}

export interface AgentCourse {
  id: number
  title: string
  topic: string
  sourceLang: string
  targetLang: string
  difficulty: 'beginner' | 'intermediate' | 'advanced'
  totalSessions: number
  completedSessions: number
  progressPercent: number
  sessions: CourseSession[]
  nextSession?: CourseSession
  quizResults: QuizResult[]
  quizAverage: number
}

export interface AgentChatMessage {
  id: number
  role: 'user' | 'agent'
  content: string
  timestamp: string
}

export interface Agent {
  id: number
  threadId: string
  name: string
  avatarIcon: string // material icon name
  description: string
  status: AgentStatus
  statusMessage?: string
  createdAt: string
  lastActivityAt: string
  course: AgentCourse | null
  createdContents: AgentCreatedContent[]
  chatHistory: AgentChatMessage[]
}
